/* classic.icon.svg.js */

'use strict';
module.exports = {
    icon: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 768 768">
    <title></title>
    <path class="foreground-gl" d="M352 64l192 202.666v116.13l-289.202 289.203h-127.118c-35.2 0-63.68-30.4-63.68-67.556l0.32-472.889c0-37.156 28.48-67.555 63.68-67.555h224zM322.678 672l272.554-272.554 93.322 93.322-275.232 275.232h-93.322v-93.322l2.678-2.678zM320 300.445h176l-176-185.778v185.778zM760.72 385.51c9.706 9.706 9.706 25.382 0 35.088l-45.539 45.542-93.322-93.322 45.542-45.539c9.706-9.707 25.382-9.707 35.088 0l58.231 58.231z"></path>
    </svg>
    `
};